import * as React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import DeliverableHeader from '../../../deliverables/components/header-v2/DeliverableHeader';
import OutfitTimeline from './OutfitTimeline';
import OutfitMediaToView from 'modules/realm-outfits/components/outfit-media-to-view/OutfitMediaToView';
import Spinner from 'components/spinner/Spinner';

import { danger } from 'redux-store/reducers/common-reducer';

import { __t, applyTranslations } from 'utils/language';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { getCCMCampaignStatus } from 'modules/campaigns/components/ccm/create/utils/ccm-outfits-statuses';

import './campaign-zalando-outfit.scss';

applyTranslations(require('./campaign-zalando-outfit.i18n.json'));

import { Campaign, PreviewOutfit } from 'types';
import { CcmCampaignTimeline } from 'modules/campaigns/components/ccm/types';

type StateProps = {
  campaign: Campaign & { timeline: CcmCampaignTimeline}
}

type DispatchProps = {
  dispatchShowErrorNotification: (msg: string) => void
}

type OwnProps = {
  campaignId: string
};

type Props = OwnProps & StateProps & DispatchProps;

const msgKey = 'campaign_zalando_outfit';

const CampaignZalandoOutfit = ({
  campaign,
  campaignId,
  dispatchShowErrorNotification
}: Props) => {
  const [outfits, setOutfits] = React.useState<Array<PreviewOutfit> | null>(null);

  React.useEffect(() => {
    (async () => {
      const url = API.END_POINTS.CAMPAIGNS.getZalandoOutfits(campaignId, ['published']);

      try {
        const { data } = await get(url);

        setOutfits(data);
      } catch (error) {
        dispatchShowErrorNotification(__t(`${msgKey}.labels.error`));

        logError(error);
      }
    })();
  }, [campaignId]);

  const mainContainer = () => {
    const headerClasses = classNames('campaign-zalando-outfit__outfits-header', {
      'campaign-zalando-outfit__outfits-header--no-outfits': !outfits?.length
    });

    return (
      <React.Fragment>
        <div className="campaign-zalando-outfit__header-container">
          <DeliverableHeader
            deliverable={{
              id: Math.random(),
              deliverableType: 'zalando_outfit',
              name: campaign.name
            }}
          />
        </div>
        <div className="campaign-zalando-outfit__timeline-container">
          <OutfitTimeline
            startDate={campaign.timeline.taskContentGoLiveDate}
            endDate={campaign.timeline.taskContentGoLiveEndDate}
            statusToRender={getCCMCampaignStatus(campaign.timeline)}
          />
        </div>
        <div className={headerClasses}>
          <div className="campaign-zalando-outfit__title">
            {__t(`${msgKey}.labels.title`)}
          </div>
          <div className="campaign-zalando-outfit__info">
            {__t(`${msgKey}.labels.${outfits?.length ? 'info' : 'no_outfits'}`)}
          </div>
        </div>
        <div className="campaign-zalando-outfit__outfits-container">
          {
            (outfits || []).map(outfit => (
              <OutfitMediaToView
                key={outfit.id}
                outfit={outfit}
              />
            ))
          }
        </div>
      </React.Fragment>
    );
  };

  const containerClasses = classNames('campaign-zalando-outfit', {
    'campaign-zalando-outfit--loading': !campaign.id
  });

  return (
    <div className={containerClasses}>
      {
        campaign.id ? mainContainer() : <Spinner />
      }
    </div>
  );
};

const mapStateToProps = ({
  campaignBrief
}): StateProps => ({
  campaign: campaignBrief.brief
});

export const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchShowErrorNotification: (msg: string) => dispatch(danger(msg))
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignZalandoOutfit);
